const applyDefaultCurrencyOn = (currentValue, defaultCurrency) => {
  const { amount, currency, ...otherProps } = currentValue;
  if (!currency || currency === '') {
    return {
      amount,
      currency: defaultCurrency,
      ...otherProps,
    };
  }

  return currentValue;
};

export default applyDefaultCurrencyOn;
